import React, { Component } from "react";
import { connect } from 'dva';
import Container from "@/components/Container";
import Iframe from "@/components/Iframe";
import { parse } from "qs";

@connect(({ user }) => ({
  orgId: user?.currentUser?.orgId,
}))
export default class LearnCity extends Component {
  render() {
    const { appId, suitId, orgId } = parse(window.location.search?.split("?")[1]) || {};
    const orgid = !orgId ? this.props?.orgId : orgId;

    if (!orgid) {
      return null
    }

    const IframeDom = Iframe({
      src: `//rdp3.xiaoyuanhao.com/RDP-SERVER/rdppage/main/173c91c691f9c12c704e30f5cc551933?orgId3=${orgid}&appId=${appId || 173}&suitId=${suitId}`
    });

    return (
      <Container breStates defaultPadding>
        <div style={{padding: '9px 17px'}}>
          <IframeDom />
        </div>
      </Container>
    );
  }
}
